<template>
  <div id="app">
    <div v-if="!loading && landing && !distroMusicPage">
      <router-view/>
    </div>
    <div id="app-wrapper" v-if="user && user._id && !landing && !blogPage && !distroMusicPage">
      <Header v-if="!fromApp"></Header>
      <Sidebar v-if="!fromApp" class="block-desktop"></Sidebar>
      <SidebarMobile v-if="!fromApp" class="block-mobile"></SidebarMobile>
      <div class="main-panel" :class="{ 'in-review': (user.hasArtistValid && !user.verified), 'bg-dark': gamificationPage }">
        <router-view/>
        <Footer v-if="!fromApp"></Footer>
      </div >
      <PriceComparisonModal></PriceComparisonModal>
    </div>

    <div v-if="!loading && blogPage" class="v-application v-application--is-ltr">
      <router-view/>
    </div>

    <router-view v-if="!loading && distroMusicPage" />

    <div ref="modalBlocker" class="modal" tabindex="-1" role="dialog" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold">
              <i class="fa fa-exclamation-triangle mr-1 text-warning"></i>
              {{ $t('ad_blocker_detected') }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <p>
              {{ $t('please_disable_ad_blocker') }}
            </p>
            <p class="fw-bold">
              {{ $t('we_dont_ads') }}
            </p>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              {{ $t('understood') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'

import Auth from './services/auth'
import User from './services/user'
import Artists from './services/artists'
import Header from './components/Header'
import Sidebar from './components/SidebarCollapse'
import SidebarMobile from './components/Sidebar'
import Footer from './components/Footer'

import PriceComparisonModal from './components/PriceComparisonModal.vue'

export default {
  name: 'App',
  data: function () {
    return {
      lang: 'en',
      landing: false,
      loading: true,
      blogPage: false,
      distroMusicPage: false,
      user: null,
      hasArtistValid: null,
      gamificationPage: false,
      fromApp: false,
      publicRoutes: [
        '/',
        '/home',
        '/promo',
        '/live',
        '/mastering',
        '/playlists',
        '/spotify-auth',
        '/release',
        '/our-artists',
        '/login',
        '/signup',
        '/landing',
        '/landing/artists',
        '/landing/pricing',
        '/landing/labels',
        '/landing/about-us',
        '/landing/mastering',
        '/landing/how-it-works',
        '/public/image-upload',
        '/record-label',
        '/free-music-distribution',
        '/distribucion-digital-gratuita',
        '/music-distribution-and-monetization',
        '/apply',
        '/pro',
        '/terms',
        '/distribucion-musical-gratis',
        '/free-online-music-distribution',
        '/pro-weekend'
      ]
    }
  },
  methods: {
    isBusinessHours: function () {
      const mexicoTime = new Date().toLocaleString('en-US', { timeZone: 'America/Mexico_City' })
      const currentTime = new Date(mexicoTime)
      const hours = currentTime.getHours()
      const minutes = currentTime.getMinutes()
      const dayOfWeek = currentTime.getDay()

      if (dayOfWeek === 0 || dayOfWeek === 6) {
        return false
      }

      if (hours >= 9 && hours < 17) {
        return true
      } else if (hours === 17 && minutes <= 30) {
        return true
      }

      return false
    },
    initSupportWidget: function () {
      // if (!this.user || !this.isBusinessHours()) {
      // let script = document.createElement('script')
      // script.type = 'text/javascript'
      // script.src = 'https://cdn.botpress.cloud/webchat/v2.2/inject.js'
      // window.$('body').append(script)

      // setTimeout(() => {
      //   let script2 = document.createElement('script')
      //   script2.type = 'text/javascript'
      //   script2.src = 'https://files.bpcontent.cloud/2024/11/27/17/20241127173247-EFD46R45.js'
      //   window.$('body').append(script2)
      // }, 200)
      // } else {
      let zeScript = document.createElement('script')
      zeScript.id = 'ze-snippet'
      zeScript.type = 'text/javascript'
      zeScript.src = 'https://static.zdassets.com/ekr/snippet.js?key=a39f0a58-1b8b-45d5-9558-4d244f0dfb95'
      window.$('body').append(zeScript)
      // }
    },
    updateSupportData: function () {
      setTimeout(() => {
        const $zopim = window.$zopim
        let phoneNumber = ''

        if (!this.$user._id) {
          return
        }

        if (this.$user.phone_number) {
          if (this.$user.phone_code) {
            phoneNumber = this.$user.phone_code + this.$user.phone_number
          } else {
            phoneNumber = this.$user.phone_number
          }
        }

        let lang = window.navigator.userLanguage || window.navigator.language.split('_')[0]
        lang = lang.split('-')[0]

        if (this.lang) {
          lang = this.lang
        }

        if ($zopim) {
          $zopim.livechat.setName(this.$user.name || this.$user.username)
          $zopim.livechat.setEmail(this.$user.email)

          if (phoneNumber) {
            $zopim.livechat.setPhone(phoneNumber)
          }

          if (lang === 'es') {
            $zopim.livechat.setLanguage('es')
          }
        }

        window.zE && window.zE('webWidget', 'identify', {
          name: this.$user.name || this.$user.username,
          email: this.$user.email
        })

        window.botpress && window.botpress.updateUser({
          FullName: this.$user.name,
          Email: this.$user.email,
          indiefy_id: this.$user._id
        }).then(() => {
        }).catch(() => {
        })

        if ($zopim && this.$user.subscription && this.$user.subscription.plan_name !== 'indiefy_lite') {
          $zopim.livechat.addTags('pro_user')
          $zopim.livechat.set({
            pro_user: 1
          })
          $zopim.livechat.setStatus('online')
          window.zE && window.zE('webWidget', 'chat:addTags', 'pro_user')
        } else if ($zopim) {
          $zopim.livechat.removeTags('removeTags')
          $zopim.livechat.setStatus('offline') // Disable chat
        }
      }, 1500)
    },
    checkLogin: async function () {
      let artist = null

      try {
        artist = await Artists.getAll({ limit: 1 })
      } catch (error) {}

      Auth.getUser().then(response => {
        if (artist) {
          response.data.hasArtistValid = !!artist.data.length
        }

        _.extend(this.$user, response.data)

        window.smartlook && window.smartlook('identify', this.$user._id, {
          email: this.$user.email,
          name: this.$user.name || this.$user.username
        })

        this.user = response.data
        this.initSupportWidget()
        this.updateSupportData()

        if (_.includes(this.publicRoutes, this.$route.path) || this.$route.path.match(/\/our-artists\//) || this.$route.path.match(/\/release\//)) {
          this.landing = true
        }

        if (this.$route.path.match('blog')) {
          this.blogPage = true
        }

        if (['distribucion-musical-gratis', 'free-online-music-distribution', 'pro-weekend'].indexOf(this.$route.path) !== -1) {
          this.distroMusicPage = true
        } else {
          this.distroMusicPage = false
        }

        if (this.user && this.user._id && this.user.lang !== this.lang) {
          console.log('Update language')
          User.update({ lang: this.lang }).then(() => {})
        }

        this.loading = false
      }).catch(() => {
        this.initSupportWidget()
        this.updateSupportData()

        this.loading = false
        if (this.$route.path.match('blog')) {
          this.blogPage = true
        } else {
          this.landing = true
        }

        if (this.$route.path.match('blog')) {
          this.blogPage = true
        }

        if (['distribucion-musical-gratis', 'free-online-music-distribution', 'pro-weekend'].indexOf(this.$route.path) !== -1) {
          this.distroMusicPage = true
        } else {
          this.distroMusicPage = false
        }

        if (!_.includes(['/services', '/upgrade'].concat(this.publicRoutes), this.$route.path) && !this.$route.path.match(/\/blog|\/release\/|\/our-artists/)) {
          this.$router.push(`/login?next=${this.$route.path}`)
        }
      })
    }
  },
  mounted: function () {
    window.zE && window.zE('webWidget:on', 'open', () => {
      if (this.$user && this.$user.subscription) {
        window.$zopim.livechat.setStatus('online')
      } else {
        window.$zopim.livechat.setStatus('offline')
      }
    })
  },
  created: function () {
    if (this.$route.query.ref) {
      localStorage.setItem('referral', this.$route.query.ref)
    }

    if (localStorage.getItem('utm_campaign') === 'undefined') {
      localStorage.removeItem('utm_campaign')
    }

    if (localStorage.getItem('utm_medium') === 'undefined') {
      localStorage.removeItem('utm_medium')
    }

    if (localStorage.getItem('utm_source') === 'undefined') {
      localStorage.removeItem('utm_source')
    }

    if (this.$route.query.utm_campaign) {
      localStorage.setItem('utm_campaign', this.$route.query.utm_campaign)

      if (this.$route.query.utm_medium) {
        localStorage.setItem('utm_medium', this.$route.query.utm_medium)
      }

      if (this.$route.query.utm_source) {
        localStorage.setItem('utm_source', this.$route.query.utm_source)
      }
    }

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
      localStorage.setItem('defaultLang', this.$route.query.lang)
    }

    if (this.lang === 'en') {
      window.$('link[hreflang="en"]').remove()
    }

    this.checkLogin()

    if (this.$route.path.match(/challenges/)) {
      this.gamificationPage = true
    } else {
      this.gamificationPage = false
    }

    this.$eventBus.$on('updateUser', async user => {
      if (user === null) {
        this.$user = {}
      } else {
        try {
          let artist = await Artists.getAll({ limit: 1 })
          user.hasArtistValid = !!artist.data.length
        } catch (error) {}
        _.extend(this.$user, user)
      }

      this.user = user
      this.loading = false

      if (this.user && this.user._id) {
        window.smartlook && window.smartlook('identify', this.user._id, {
          email: this.user.email,
          name: this.user.name || this.user.username
        })

        if (!window.actionBarInit && navigator.userAgent.indexOf('gonative') > -1) {
          let style = 'dark'
          let color = '17BEBB'

          if (this.user && this.user.subscription) {
            style = 'dark'
            color = '212529'
          }

          window.gonative && window.gonative.statusbar.set({
            style: style,
            color: color
          })

          window.actionBarInit = true
        }
      }

      this.updateSupportData()
    })

    let adBlockEnabled = false
    window['testAd'] = document.createElement('div')
    window['testAd'].innerHTML = '&nbsp;'
    window['testAd'].className = 'adsbox'
    document.body.appendChild(window['testAd'])
    window.setTimeout(() => {
      if (window['testAd'].offsetHeight === 0) {
        adBlockEnabled = true
      }

      window['testAd'].remove()

      if (adBlockEnabled) {
        window.$(this.$refs.modalBlocker).modal('show')

        if (window.ga) {
          window.ga('send', 'event', 'Blocking Ads', 'Yes', { 'nonInteraction': 1 })
        } else if (window._gaq) {
          window._gaq.push(['_trackEvent', 'Blocking Ads', 'Yes', undefined, undefined, true])
        }
      }
    }, 100)

    this.fromApp = window.accessToken
  },
  watch: {
    '$route' (to, from) {
      this.currentPage = to.name

      if (_.includes(this.publicRoutes, this.$route.path) || this.$route.path.match(/\/our-artists\//) || this.$route.path.match(/\/release\//)) {
        this.landing = true
      } else {
        this.landing = false
      }

      if (['distribucion-musical-gratis', 'free-online-music-distribution', 'pro-weekend'].indexOf(this.$route.path) !== -1) {
        this.distroMusicPage = true
      } else {
        this.distroMusicPage = false
      }

      if (this.$route.path.match(/challenges/)) {
        this.gamificationPage = true
      } else {
        this.gamificationPage = false
      }

      if (this.$route.path.match('blog')) {
        this.blogPage = true
      } else {
        this.blogPage = false
      }

      if (this.$route.path.match(/\/upgrade|\/services/)) {
        setTimeout(() => {
          if ((!this.user || !this.user._id)) {
            this.landing = true
          } else if (this.user && this.user._id) {
            this.landing = false
          }
        }, 500)
      }

      window._hsq && window._hsq.push(['trackPageView'])
    }
  },
  components: {
    Header,
    Sidebar,
    SidebarMobile,
    Footer,
    PriceComparisonModal
  }
}
</script>

<style lang="scss">
@import "assets/sass/atlantis";
@import "assets/sass/wizard";
@import "assets/sass/select2";
@import "assets/sass/datepicker";
@import "assets/sass/tags";
@import "assets/sass/player";
@import "assets/sass/vectormap";
@import "assets/sass/custom-animations";
// @import "assets/sass/invoice";
// @import "assets/sass/messages";
@import "assets/sass/rating";
@import "assets/sass/toggle";
@import "assets/sass/select2Custom";
@import "assets/sass/datepickerCustom";
@import "assets/sass/inputs-custom";
@import "assets/sass/typography-custom";
@import "assets/sass/navbar-custom";
@import "assets/sass/buttons-custom";
@import "assets/sass/background-custom";
@import "assets/sass/custom";
@import "assets/sass/battery";
@import "assets/sass/navtabs-custom";

html {
  min-height: 100%;
}

body {
  margin: 0;
}

#app {
  min-height: 100%;
  height: 100%;
  background-color: #ffffff;
}

.pos-relative {
  position: relative;
}

.line-through {
  text-decoration: line-through;
}

// #app-wrapper {
//   background-color: #f9fbfd;
// }
.block-desktop{
  display: none;
}

.block-mobile{
  display: block;
}

@media screen and (min-width: 991px) {
  .block-desktop{
    display: block;
  }

  .block-mobile{
    display: none;
  }
}

@media screen and (max-width:576px) {
  .form-group {
    label {
      text-align: left !important;
    }
  }

  .hide-mobile {
    display: none !important;
  }
}

.audioplayer-volume {
  display: none;
}

.country-selector__label,
.input-tel__label {
  font-size: 11px !important;
}

select.form-control {
  height: 40px !important;
}

.guest-top {
  padding-top: 60px;
}

.live-editor {
  .toggle-off.btn {
    padding-left: 40px;
  }
}

.post-content {
  img {
    width: 100%;
  }

  p, h1, h2, h3 {
    font-family: medium-content-serif-font, Georgia, Cambria, "Times New Roman", Times, serif;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  p {
      font-size: 22px;
  }

  h2, h2 > span {
    font-size: 36px !important;
    font-weight: bold;
  }

  h3 {
    font-size: 24px;
    font-weight: bold;
  }

  h1 {
    font-size: 60px !important;
    font-weight: bold;
  }
}

.v-application {
  background: #FFFFFF;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  position: relative;
}

@-moz-document url-prefix() {
  @media print {
    .v-application {
      display: block;
    }
    .v-application--wrap {
      display: block;
    }
  }
}

.gamification-page {
  background: #2E294E
}

.gamification-page .nav-tabs .nav-link {
  color: #aaa;
}

.gamification-page .nav-line {
  border-bottom: none;
}

.gamification-page .nav-tabs .nav-link.active {
  color: white;
}

.gamification-page .card-header {
  border-bottom: #2E294E !important;
}

.gamification-page .card-footer,
.gamification-page .user-stats .col {
  border-color: #2e294e !important;
}

.badge-pro {
  border-radius: 3px;
}

.fw-400 {
  font-weight: 400;
}

.fw-700 {
  font-weight: 700;
}

.fw-200 {
  font-weight: 200;
}

.blink {
  animation: blinker 3s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.animated-bg {
  width: 300px;
  height: 200px;
  background: #5714ff;
  animation: animatedBg 5s infinite;
}

@keyframes animatedBg {
  from { background-color: #5714ff; }
  to { background-color: #b80d51; }
}

.btn-gray {
  background: #ededed;
  color: black;
}

.cookie-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #5714ff;
  padding: 15px 20px;
  font-family: 'Poppins';
  z-index: 999999;
}

.cookie-fixed p{
  color: #FFFFFF;
  display: inline-block;
  margin: 0;
  vertical-align: sub;
}

.cookie-fixed .btn-cookie{
  float: right;
}

.cookie-fixed .btn {
  margin-left: 5px;
}
.cookie-fixed .btn.btn-succes{
  min-width: 90px;
}

@media screen and (max-width: 992px) {
  .cookie-fixed p{
    display: block;
  }
  .cookie-fixed .btn-cookie{
    float: none;
  }
  .cookie-fixed .btn {
    margin-left: 0;
    margin-right: 5px;
  }
  .cookie-fixed .btn.btn-succes{
    float: right;
  }
  .cookie-fixed p{
    margin-bottom: 5px;
  }
}

iframe#launcher {
  z-index: 1000 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue